import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
import { useGoalList } from "../Register/GoalListContext";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

/* 笏笏 繧｢繝九Γ繝ｼ繧ｷ繝ｧ繝ｳ 笏笏 */
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const gradientShift = keyframes`
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const shimmer = keyframes`
  0%   { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

/* 笏笏 繝ｬ繧､繧｢繧ｦ繝・笏笏 */
const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(-45deg, #0f0c29, #302b63, #24243e, #1a1a2e);
  background-size: 400% 400%;
  animation: ${gradientShift} 12s ease infinite;
  padding: 40px 16px 60px;
`;

const PageTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 8px;
`;

const PageTitleIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4);
  flex-shrink: 0;
`;

const PageTitle = styled.h1`
  font-size: clamp(1.4rem, 4vw, 2rem);
  font-weight: 900;
  background: linear-gradient(90deg, #ffd700, #ff8c00, #ffd700);
  background-size: 200% auto;
  animation: ${shimmer} 3s linear infinite;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

const PageSub = styled.p`
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: clamp(0.8rem, 2vw, 0.95rem);
  margin-bottom: 32px;
  animation: ${fadeInUp} 0.6s ease 0.1s both;
`;

const SearchCard = styled.div`
  max-width: 800px;
  margin: 0 auto 24px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 28px 24px;
  animation: ${fadeInUp} 0.6s ease 0.15s both;
`;

/* 笏笏 繧ｭ繝ｼ繝ｯ繝ｼ繝画､懃ｴ｢ 笏笏 */
const KeywordRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 28px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const KeywordInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border-radius: 50px;
  border: 2px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
  &::placeholder { color: rgba(255, 255, 255, 0.35); }
  &:focus { border-color: #ffd700; }
`;

const KeywordBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 28px;
  border-radius: 50px;
  border: none;
  background: linear-gradient(135deg, #f12711, #f5af19);
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(245, 175, 25, 0.4);
  }
  @media (max-width: 600px) {
    width: 100%;
    font-size: 0.95rem;
  }
`;

/* 笏笏 繧ｻ繧ｯ繧ｷ繝ｧ繝ｳ 笏笏 */
const SectionLabel = styled.h3`
  font-size: clamp(0.85rem, 2.5vw, 1rem);
  font-weight: 700;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

/* 笏笏 繧ｿ繧ｰ / 繧ｫ繝・ざ繝ｪ繝懊ち繝ｳ 笏笏 */
const TagGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
  min-width: 0;
`;

const TagChip = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  padding: 7px 16px;
  border-radius: 50px;
  border: 1px solid ${(props) => (props.$active ? "#ffd700" : "rgba(255,255,255,0.2)")};
  background: ${(props) => (props.$active ? "rgba(255,215,0,0.15)" : "rgba(255,255,255,0.06)")};
  color: ${(props) => (props.$active ? "#ffd700" : "rgba(255,255,255,0.65)")};
  font-size: clamp(0.78rem, 2.2vw, 0.88rem);
  font-weight: 600;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
  line-height: 1.3;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    border-color: #ffd700;
    color: #ffd700;
    background: rgba(255, 215, 0, 0.1);
  }
`;

/* 笏笏 繧｢繧ｯ繧ｷ繝ｧ繝ｳ繝懊ち繝ｳ 笏笏 */
const ActionRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const SearchSubmitBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  min-width: max-content;
  padding: 14px 36px;
  border-radius: 50px;
  border: none;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  box-sizing: border-box;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
  @media (max-width: 600px) {
    width: 100%;
    min-width: unset;
    padding: 14px 24px;
    font-size: 0.95rem;
  }
`;

const ClearBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  border-radius: 50px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
  font-size: clamp(0.85rem, 2.5vw, 0.95rem);
  box-sizing: border-box;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    border-color: #fff;
    color: #fff;
  }
  @media (max-width: 600px) {
    width: 100%;
    padding: 14px 24px;
  }
`;

/* 笏笏 繧ｳ繝ｳ繝昴・繝阪Φ繝・笏笏 */
const RegisterSearchView = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);
  const [keyword, setKeyword] = useState("");

  const navigate = useNavigate();
  const { setGoals } = useGoalList();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const toggleCategory = (cat) =>
    setSelectedCategory((prev) => (prev === cat ? null : cat));
  const toggleTag = (tag) =>
    setSelectedTag((prev) => (prev === tag ? null : tag));
  const clearSelection = () => {
    setSelectedCategory(null);
    setSelectedTag(null);
  };

  const handleError = (error) => {
    const code = error?.response?.status;
    if (code === 401) toast.warn("認証エラーです。いったんログインし直してください。");
    else if (code === 400) toast.info("入力条件に誤りがあります。");
    else if (code === 500) toast.error("サーバーエラーが発生しました。");
    else toast.error("予期せぬエラーが発生しました。");
  };

  const searchByKeyword = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/search/goals/?search=${keyword}`
      );
      if (Array.isArray(res.data)) {
        setGoals(res.data);
        navigate("/RegisterSearchResult");
      }
    } catch (err) {
      handleError(err);
    }
  };

  const searchByFilter = async (e) => {
    e.preventDefault();
    try {
      const params = new URLSearchParams();
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedTag) params.append("tags", selectedTag);
      const res = await axios.get(
        `${API_BASE_URL}/api/search/goals/?${params.toString()}`
      );
      if (Array.isArray(res.data)) {
        setGoals(res.data);
        navigate("/RegisterSearchResult");
      }
    } catch (err) {
      handleError(err);
    }
  };

  const categories = [
    { key: "sports", label: "\u30b9\u30dd\u30fc\u30c4" },
    { key: "company", label: "\u4f1a\u793e" },
    { key: "entrepreneurship", label: "\u8d77\u696d" },
    { key: "career", label: "\u8077\u696d\u30fb\u30ad\u30e3\u30ea\u30a2" },
    { key: "romance", label: "\u604b\u611b" },
    { key: "study", label: "\u8cc7\u683c\u30fb\u52c9\u5f37" },
    { key: "self_satisfaction", label: "\u81ea\u5df1\u6e80\u8db3" },
    { key: "literature", label: "\u6f2b\u753b\u3001\u6587\u5b66" },
  ];

  const tags = [
    "\u30a8\u30f3\u30b8\u30cb\u30a2",
    "CEO",
    "\u8d77\u696d",
    "\u8cc7\u683c",
    "\u8ca1\u52d9",
    "\u6295\u8cc7",
    "\u30c0\u30a4\u30a8\u30c3\u30c8",
    "\u5065\u5eb7",
    "\u901f\u8aad",
    "\u30e1\u30b8\u30e3\u30fc\u30ea\u30fc\u30b0",
    "\u30a2\u30a4\u30c9\u30eb",
    "\u30bb\u30ea\u30a2A",
    "coffee",
    "\u30d1\u30f3",
    "\u4e16\u754c\u65c5\u884c",
    "\u30d0\u30eb\u30bb\u30ed\u30ca",
    "\u30bf\u30fc\u30ca\u30fc\u8cde",
    "\u30d1\u30ea\u30b3\u30ec",
    "\u30b0\u30e9\u30df\u30fc\u8cde",
    "\u30aa\u30b9\u30ab\u30fc",
    "\u30ce\u30fc\u30d9\u30eb\u8cde",
    "\u30ce\u30fc\u30d9\u30eb\u6587\u5b66\u8cde",
    "\u30d5\u30a3\u30fc\u30eb\u30ba\u8cde",
    "M1\u512a\u52dd",
    "\u30c0\u30fc\u30d3\u30fc\u30b8\u30e7\u30c3\u30ad\u30fc",
    "\u7406\u5b66\u30e9\u30a4\u30c0\u30fc",
    "\u6f2b\u753b\u5bb6",
    "\u5f01\u8b77\u58eb",
    "\u4e16\u754c\u4e00\u5468",
    "\u30d5\u30a1\u30f3",
  ];


  return (
    <PageWrapper>
      <PageTitleRow>
        <PageTitleIcon>
          <FontAwesomeIcon icon={faMagnifyingGlass} color="#fff" size="lg" />
        </PageTitleIcon>
        <PageTitle>無謀な夢を探す</PageTitle>
      </PageTitleRow>
      <PageSub>キーワードやカテゴリから、気になる無謀な夢を見つけよう</PageSub>

      <SearchCard>
        <SectionLabel>キーワードで探す</SectionLabel>
        <KeywordRow>
          <KeywordInput
            maxLength={20}
            value={keyword}
            placeholder="キーワードを入力..."
            onChange={(e) => setKeyword(e.target.value)}
          />
          <KeywordBtn onClick={searchByKeyword}>検索</KeywordBtn>
        </KeywordRow>

        <SectionLabel>カテゴリ</SectionLabel>
        <TagGrid>
          {categories.map((c) => (
            <TagChip
              key={c.key}
              $active={selectedCategory === c.key}
              onClick={() => toggleCategory(c.key)}
            >
              {c.label}
            </TagChip>
          ))}
        </TagGrid>

        <SectionLabel>#タグ</SectionLabel>
        <TagGrid>
          {tags.map((t) => (
            <TagChip
              key={t}
              $active={selectedTag === t}
              onClick={() => toggleTag(t)}
            >
              #{t}
            </TagChip>
          ))}
        </TagGrid>

        <ActionRow>
          <SearchSubmitBtn onClick={searchByFilter}>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
            この条件で検索する
          </SearchSubmitBtn>
          <ClearBtn onClick={clearSelection}>選択をクリア</ClearBtn>
        </ActionRow>
      </SearchCard>

      <ToastContainer position="top-center" autoClose={3000} />
    </PageWrapper>
  );
};

export default RegisterSearchView;
